// extracted by mini-css-extract-plugin
module.exports =  {"tag":"TagPrimitive-module__tag___YyJdu"};